import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Logo from "@/components/Logo";
import Button from "@/components/Button";
import { Field } from "@/components/Form";
import { Eyebrow, Headline } from "@/components/Editorial";
import PortalToggle from "@/components/PortalToggle";
import { apiPost } from "@/lib/api";
import { toast } from "@/components/Toast";
import { C } from "@/lib/brand";

export default function ForgotPassword() {
  const [searchParams] = useSearchParams();
  // Prefill from `?email=` so a member landing here from the sign-in
  // error band doesn't have to retype.
  const [email, setEmail] = useState(searchParams.get("email") || "");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await apiPost("/consumer/auth/forgot-password", { email }, { auth: false });
      setSent(true);
    } catch (err) {
      toast(err.detail || "We hit a snag sending that reset email. Please try again in a moment.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="forgot-password-page" style={{ minHeight: "100vh", background: C.cream }}>
      <header style={{ background: C.ink, padding: "20px 24px" }}>
        <Link to="/sign-in"><Logo light size={22} /></Link>
      </header>
      <div style={{ display: "flex", justifyContent: "center", padding: 24 }}>
        <form onSubmit={submit} style={{ width: "100%", maxWidth: 460, background: C.pure, padding: "48px 36px", border: `1.5px solid ${C.warmGray3}`, marginTop: 40 }}>
          <Eyebrow>★ RESET</Eyebrow>
          <Headline before="FORGOT" italic="password?" size={56} className="mt-4" />
          <div style={{ marginTop: 20 }}>
            <PortalToggle active="member" />
          </div>
          {sent ? (
            <div style={{ marginTop: 32, fontSize: 15, color: C.ink, lineHeight: 1.6 }} data-testid="forgot-password-sent-msg">
              If an account exists for <strong>{email}</strong>, we've sent reset instructions. Check your inbox.
              <div style={{ marginTop: 24 }}>
                <Link to="/sign-in" data-testid="forgot-back-link" style={{ fontSize: 12, fontWeight: 800, letterSpacing: "0.18em", color: C.ink, textDecoration: "none" }}>← BACK TO SIGN IN</Link>
              </div>
            </div>
          ) : (
            <>
              <p style={{ marginTop: 18, color: C.warmGray, fontSize: 15, lineHeight: 1.55 }}>
                Enter your email and we'll send you a link to reset your password.
              </p>
              <Field label="EMAIL" type="email" name="email" id="forgot-email" autoComplete="username" value={email} onChange={setEmail} placeholder="you@email.com" testId="forgot-email-input" autoFocus />
              <div style={{ marginTop: 28 }}>
                <Button type="submit" variant="primary" block testId="forgot-submit-btn" disabled={loading}>
                  {loading ? "SENDING…" : "SEND RESET LINK →"}
                </Button>
              </div>
            </>
          )}
        </form>
      </div>
    </div>
  );
}
